import { Formik } from "formik";
import Input from "../shared/Input/Input";
import Button from "@mui/material/Button";
import "./Register.scss";
import { useLazyValidateBpSiteIdQuery } from "../../services/rtkQueryServices/authenticationService";
import { useState } from "react";
import { dataStore } from "../../constants/dataStore";
import { InstructionsPage } from "./InstructionsPage/InstructionsPage";
import { UserService } from "../../services/UserService";

const BpSiteIdVerification = (props: any) => {
  const { formRef } = props;
  const [validateBpSiteId] = useLazyValidateBpSiteIdQuery();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const handleNextPage = () => {
    props.nextStep();
    UserService.currentStep = "3";
  };
  return (
    <div className="register-form-container instructions-wrapper d-flex flex-column d-flex flex-column">
      <div className="h-100">
        <div className="register-header text-align-center align-self-center p-4">
          Connect to Inca Evo
        </div>

        <Formik
          innerRef={formRef}
          initialValues={{ bpSiteId: "" }}
          onSubmit={(values) => {
            validateBpSiteId({
              bpSiteId: values.bpSiteId,
            }).then((res) => {
              handleNextPage();
            });
          }}
        >
          {(formik) => (
            <form
              //   onKeyDown={Utility.preventSubmitOnEnter}
              onSubmit={formik.handleSubmit}
              className="d-flex flex-column registration-form instructions-container align-items-center"
            >
              <InstructionsPage />
              <div className="pt-3 bp-site-input">
                <Input
                  name="bpSiteId"
                  placeholder="BP Site ID"
                  onChange={formik.handleChange}
                  onInput={() => {
                    setErrorMessage("");
                  }}
                  value={formik.values.bpSiteId}
                  errorMsg={
                    (formik.touched.bpSiteId || formik.submitCount > 0) &&
                    formik.errors.bpSiteId &&
                    (formik.errors as any).bpSiteId
                  }
                  maxLength={64}
                  label="BP Site ID"
                />
              </div>
              {errorMessage && (
                <div className="error-message align-self-center">
                  {errorMessage}
                </div>
              )}

              <div className="d-flex justify-content-end flex-column gap-3 line-top py-3 registration-form-button register-submission">
                <Button
                  variant="contained"
                  type="submit"
                  disabled={!formik.isValid || !formik.dirty}
                >
                  Submit
                </Button>
                <Button
                  className="link-button"
                  onClick={() => {
                    handleNextPage();
                  }}
                >
                  Skip for now
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
export default BpSiteIdVerification;
